export type TimeslotChooserStyle = 'Range List' | 'Simple List' | 'Hours - Minutes';
export const TimeslotChooserStyle = {
  RangeList: 'Range List' as TimeslotChooserStyle,
  SimpleList: 'Simple List' as TimeslotChooserStyle,
  HoursMinutes: 'Hours - Minutes' as TimeslotChooserStyle,
};
